import React, { Component } from "react";

import { Redirect } from 'react-router-dom';
import { Typography, Tabs, List, Divider, Row, Card, Col } from 'antd';
import Core from "../../Core.js";

import './index.scss';

const { Title } = Typography;
const { TabPane } = Tabs;

export default class ScheduleContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirectLogin: false,
      loading: false,
      data: [],
      page: [],
    };
  }

  componentDidMount() {
    if (Core.data().config.private == true && Core.data().login == null) {
      this.setState({ redirectLogin: true });
    } else {
      this.loadSchedule();
      this.loadIntroduction();
    }
  }

  loadIntroduction() {
    this.setState({ loading: true });
    Core.apiData(`pages/schedules.json`, {
      onSuccess: (data) => {
        if (data.json) {
          this.setState({
            page: data.json,
          });
          this.loadSchedule();
        } else {
          this.setState({ error: true });
          console.log("Schedule introduction is not a JSON!");
        }
      },
      onFail: (data) => {
        this.setState({ error: true });
        console.log("Schedule introduction failed.", data);
      },
    });
    this.setState({ loading: false });
  }

  loadSchedule() {
    Core.apiData(`schedules/list.json`, {
      onSuccess: (data) => {
        if (data.json) {
          this.setState({
            data: data.json,
          });
        } else {
          this.setState({ error: true });
          console.log("Schedule data is not a JSON!");
        }
      },
      onFail: (data) => {
        this.setState({ error: true });
        console.log("Schedule data failed.", data);
      },
    });
  }

  renderSchedule(item) {
    return (
      <div className="schedule__schedule__item">
        <p
          className={`schedule__schedule__item__hour ${
            item.title === "Break" && "schedule__schedule__item__hour--break"
          }`}
        >
          {item.time.replace(":00", "").replace(":", "h")}
        </p>
        <div>
          <p
            className={`schedule__schedule__item__title ${
              item.title === "Break" && "schedule__schedule__item__title--break"
            }`}
          >
            {item.title}
          </p>
          {/* {item?.speakers.length > 0 && (
            <p className="schedule__schedule__item__speakers">
              {item.speakers.map((speaker) => speaker.name).join(", ")}
            </p>
          )} */}
        </div>
      </div>
    );
  }

  render() {
    const { redirectLogin, data } = this.state;

    if (redirectLogin) {
      window.location.assign("/login");
    }

    const tabs = [];
    let tabListItems = [];
    let tabListItemsMeta = [];
    let currentDate = null;
    let currentTimeRange = null;
    let time = null;
    for (const schedule of data) {
      schedule.date = schedule.date.replace("2020-", "");
      schedule.date = schedule.date.split("-").reverse().join("/");

      if (currentDate == null) {
        currentDate = schedule.date;
      } else if (currentDate != schedule.date) {
        tabListItems.push(
          <List.Item>
            <List.Item.Meta
              avatar={
                <Title className="tab-avatar" level={4}>
                  {currentTimeRange}
                </Title>
              }
              title={""}
              description={
                <div className="schedule__item">{tabListItemsMeta}</div>
              }
            />
          </List.Item>
        );

        tabs.push(
          <TabPane tab={currentDate} key={currentDate}>
            {tabListItems}
          </TabPane>
        );
        currentDate = schedule.date;
        currentTimeRange = null;
        tabListItems = [];
        tabListItemsMeta = [];
      }

      time = schedule.time.slice(0, -3);
      if (schedule.endtime != null && schedule.endtime != "") {
        time =
          schedule.time.slice(0, -3) + " - " + schedule.endtime.slice(0, -3);
      }

      if (
        currentTimeRange == null ||
        (currentTimeRange != null && currentTimeRange == time)
      ) {
        currentTimeRange = time;

        tabListItemsMeta.push(
          <h4 className="schedule__title">{schedule.title}</h4>
        );

        const speakers = schedule.speakers.map((speaker) => (
          <li key={speaker.uid} className="schedule__speaker">
            {speaker.name} {speaker.title ? `- ${speaker.title}` : ""}
          </li>
        ));
        tabListItemsMeta.push(speakers);
      } else if (currentTimeRange != time) {
        tabListItems.push(
          <List.Item>
            <List.Item.Meta
              avatar={
                <Title className="tab-avatar" level={4}>
                  {currentTimeRange}
                </Title>
              }
              title={""}
              description={
                <div className="schedule__item">{tabListItemsMeta}</div>
              }
            />
          </List.Item>
        );

        tabListItemsMeta = [];
        tabListItemsMeta.push(
          <h4 className="schedule__title">{schedule.title}</h4>
        );

        const speakers = schedule.speakers.map((speaker) => (
          <li key={speaker.uid} className="schedule__speaker">
            {speaker.name} - {speaker.title}
          </li>
        ));
        tabListItemsMeta.push(speakers);

        currentTimeRange = time;
      }
    }

    tabListItems.push(
      <List.Item>
        <List.Item.Meta
          avatar={
            <Title className="tab-avatar" level={4}>
              {currentTimeRange}
            </Title>
          }
          title={""}
          description={<div className="schedule__item">{tabListItemsMeta}</div>}
        />
      </List.Item>
    );

    if (currentDate != null && tabListItems.length > 0) {
      tabs.push(
        <TabPane tab={currentDate} key={currentDate}>
          {tabListItems}
        </TabPane>
      );
    }

    return (
      <div className="schedule">
        <Title level={3} className="schedule__title">
          24<sup>th</sup> October 2024 | 10h00 - 14h00 (CET)
        </Title>
        {/* <div className="schedule__content">{this.state.page.content}</div> */}
        <div className="schedule__schedule">
          <Row gutter={[32, 0]}>
            <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
              {this.state.data
                .slice(0, Math.ceil(this.state.data.length / 2))
                .map((item) => this.renderSchedule(item))}
            </Col>
            <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
              {this.state.data
                .slice(Math.ceil(this.state.data.length / 2))
                .map((item) => this.renderSchedule(item))}
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}
